import { Card, Form, Input } from 'antd';
import { CreateLayout } from '../../../components/layout/layout/CreateLayout';
import { IEcommerceDivision } from 'interfaces/ecommerce_divisions';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { SalesIconComponent } from 'assets/icons/sales';
import { useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';

export const EcommerceDivisionCreate = () => {
  const navigate = useNavigation();
  const { formProps, saveButtonProps } = useForm<IEcommerceDivision>({
    resource: 'ecommerce/divisions',
    redirect: false,
    onMutationSuccess: () => {
      navigate.push('/sales/ecommerce_divisions');
    }
  });

  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Criar Divisão" icon={SalesIconComponent} />
      <Card>
        <Form
          {...formProps}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
          style={{ maxWidth: 600 }}
        >
          <Form.Item
            label="Código"
            name="code"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
